/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_TitleInputs */

const en_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invest in the Mag7. Earn 10% APR on top.`)
};

const de_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investieren Sie in die Mag7. Verdienen Sie zusätzlich 10 % APR.`)
};

const pt_br2_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invista nas Mag7. Ganhe 10% de APR adicional.`)
};

const tr_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7’ye yatırım yapın. Ek %10 APR kazanın.`)
};

const zh_cn2_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投资 Mag7，还可额外赚取 10% 年化收益。`)
};

const zh_hk2_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投資 Mag7，額外賺取 10% 年利率。`)
};

const ko_kr2_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7에 투자하고 연 10% APR까지 받으세요.`)
};

const ru_ru2_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инвестируйте в Mag7. Получайте 10% годовых сверху.`)
};

const es_419_campaigns_mag7_title = /** @type {(inputs: Campaigns_Mag7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invierte en las Mag7 y gana 10% APR adicional.`)
};

/**
* | output |
* | --- |
* | "Invest in the Mag7. Earn 10% APR on top." |
*
* @param {Campaigns_Mag7_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_title = /** @type {((inputs?: Campaigns_Mag7_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_title(inputs)
	if (locale === "de") return de_campaigns_mag7_title(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_title(inputs)
	if (locale === "tr") return tr_campaigns_mag7_title(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_title(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_title(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_title(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_title(inputs)
	return es_419_campaigns_mag7_title(inputs)
});